var _defs, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _circle2, _circle3, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 417.284,
    height: 338,
    viewBox: "0 0 417.284 338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#18529d;stroke-miterlimit:10;stroke-width:4px;stroke-dasharray:12.07 15.09;}.b,.s{fill:#6c63ff;}.b,.l,.o,.r{opacity:0.2;}.c{fill:url(#a);}.d{fill:#fff;}.e{fill:url(#b);}.f{fill:#f6a213;opacity:0.51;}.g,.k{fill:#c76a1d;}.h{fill:#e0e0e0;}.i{fill:#f5f5f5;}.j,.l{fill:#f3c87f;}.j{opacity:0.43;}.k{opacity:0.63;}.m,.n{fill:#ff6e40;}.m{opacity:0.3;}.o,.q{fill:#157bff;}.p{fill:url(#d);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 167,
    cy: 167,
    r: 167,
    transform: "translate(27.672 2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 175.732,
    height: 111.78,
    transform: "translate(35.075 51.635)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 201.527,
    height: 114.466,
    transform: "translate(0 35.566)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 196.692,
    height: 95.121,
    transform: "translate(2.148 52.229)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 68.249,
    height: 72.012,
    transform: "translate(15.587 60.289)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 64.491,
    height: 68.787,
    transform: "translate(17.735 61.899)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M251.431,249.292a46.651,46.651,0,0,0-2.76-12,19.891,19.891,0,0,0-7.572-9.5,8.654,8.654,0,0,0-4.187-1.449c-2.76-.1-5.268,1.748-6.68,4.1a19.123,19.123,0,0,0-1.247,2.535,5.9,5.9,0,0,0-4.9,5.406,15.053,15.053,0,0,0,2.13,28.422v2.567a15.108,15.108,0,0,0-11.285,14.57v6.988h30.1v-6.988a15.108,15.108,0,0,0-11.285-14.57V266.8a15.053,15.053,0,0,0,11.285-14.575v-.106l1.693,3.768c1.61,3.588,3.262,7.444,2.636,11.327C252.438,261.93,252.181,255.374,251.431,249.292Z",
    transform: "translate(-183.439 -160.232)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M0,0H196.692V14.51H0Z",
    transform: "translate(2.148 37.719)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 74.699,
    height: 4.835,
    transform: "translate(108.555 82.054)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 74.699,
    height: 4.835,
    transform: "translate(108.555 102.476)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 44.069,
    height: 4.835,
    transform: "translate(108.016 92.263)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 30.097,
    height: 4.835,
    transform: "translate(108.016 112.685)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 30.097,
    height: 4.835,
    transform: "translate(143.487 112.685)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 99.165,
    height: 46.245,
    transform: "translate(307.022 63.956)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 106.337,
    height: 50.233,
    transform: "translate(291.431 52.9)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 99.165,
    height: 46.245,
    transform: "translate(295.342 54.097)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 57.847,
    height: 5.488,
    transform: "translate(310.367 64.209)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 30,
    height: 5.488,
    transform: "translate(310.367 76.768)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 231.329,
    height: 62.222,
    transform: "translate(185.954 257.533)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 234.697,
    height: 66.253,
    transform: "translate(171.734 243.957)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 231.329,
    height: 61.762,
    transform: "translate(173.418 246.202)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 23.141,
    cy: 23.141,
    r: 23.141,
    transform: "translate(206.809 253.945)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "q",
    cx: 20.569,
    cy: 20.569,
    r: 20.569,
    transform: "translate(209.38 256.516)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(270.443 261.66)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 36.639,
    height: 6.427
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 100.913,
    height: 6.427,
    transform: "translate(0 12.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 100.913,
    height: 6.427,
    transform: "translate(0 24.424)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M498.053,577.966l-4.518-3.446-11.906,15.6-6.643-5.07-3.446,4.513,8.907,6.8.023-.032,2.254,1.721Z",
    transform: "translate(-254.606 -309.129)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.ee608aed15dc7ae70f3942d178f32e55.svg";
export { ForwardRef as ReactComponent };